import { render, staticRenderFns } from "./stopArea.vue?vue&type=template&id=593fb383&scoped=true"
import script from "./stopArea.vue?vue&type=script&lang=js"
export * from "./stopArea.vue?vue&type=script&lang=js"
import style0 from "./stopArea.vue?vue&type=style&index=0&id=593fb383&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593fb383",
  null
  
)

export default component.exports